import React from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import "./index.scss"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import PageContainer from "components/common/PageContainer"
import TopicCard from "components/card/topic-card"
import Reviews from "components/review"
import {
  getQuestionById,
  submitForumQuestion,
  showForumModal,
  upvoteForumQuestion,
  downvoteForumQuestion,
  upvoteForumAnswer,
  downvoteForumAnswer,
  setForumAnswerData,
  setForumCommentData,
  acceptForumAnswer,
  closeForumQuestion,
} from "store/school/actions"

import { showConfirmModal, closeConfirmModal } from "store/user/actions"

import history from "app/history"

import { FORUM_MODAL_TYPES, RESPONSE_MODAL_TYPES } from "constants/modal-types"
import HeroHeader from "components/hero-header/index"
import "./index.scss"
class Topic extends React.Component {
  constructor() {
    super()

    this.state = {
      status: "",
      activePage: 1,
      searchParam: "",
      typing: false,
      typingTimeout: 0,
      enableSearch: false,
      enableButton: true,
      sort: "-date_enrolled",
      activeTab: 0,
    }
  }

  componentDidMount() {
    const {
      match: {
        params: { id },
      },
      getQuestionById,
    } = this.props

    getQuestionById(id)
  }

  componentDidUpdate(prevProps) {
    const {
      match: {
        params: { id },
      },
      getQuestionById,
    } = this.props

    const {
      match: {
        params: { id: prevId },
      },
    } = prevProps

    if (prevId !== id) {
      getQuestionById(id)
    }
  }

  submitForumQuestion = (payload) => {
    const { submitForumQuestion = false } = this.props

    if (submitForumQuestion) {
      submitForumQuestion(payload)
    }
  }

  handleEditQuestion = () => {
    const { showForumModal } = this.props

    showForumModal({
      type: FORUM_MODAL_TYPES.QUESTION,
      isEdit: true,
    })
  }

  handleEditAnswer = (answer) => {
    const { showForumModal, setForumAnswerData } = this.props

    setForumAnswerData(answer)

    showForumModal({
      type: FORUM_MODAL_TYPES.ANSWER,
      isEdit: true,
    })
  }

  handleEditComment = (comment) => {
    const { showForumModal, setForumCommentData } = this.props

    setForumCommentData(comment)

    showForumModal({
      type: FORUM_MODAL_TYPES.COMMENT,
      isEdit: true,
    })
  }

  enableSearch = () => {
    this.setState({
      enableSearch: true,
      enableButton: false,
    })
  }

  disableSearch = () => {
    this.setState({
      enableSearch: false,
      enableButton: true,
    })
  }

  handleSearch = async (e) => {
    const { name, value } = e.currentTarget

    if (e.key === "Enter" && value !== "") {
      await this.setState({
        [name]: value,
      })

      history.push(`/forums/search?keyword=${value}`)
    }
  }

  handleCloseQuestion = (question) => {
    const { closeForumQuestion, showConfirmModal } = this.props

    showConfirmModal({
      modalType: RESPONSE_MODAL_TYPES.WARNING,
      header: "Close this question?",
      message:
        "Other students will still be able to post comments or submit answers.",
      confirmLabel: "Yes, close it",
      confirmAction: () => {
        closeForumQuestion(question.id)
      },
    })
  }

  onChangeTab = (index) => {
    this.setState({
      activeTab: index,
    })
  }

  handleAddCommentToAnswer = (answer) => {
    const { showForumModal, setForumCommentData } = this.props

    answer.commentToAnswer = true
    setForumCommentData(answer)

    showForumModal({
      type: FORUM_MODAL_TYPES.COMMENT,
    })
  }

  render() {
    const {
      school: { questionData = {}, schoolData = {}, isLoadingQuestionData },
      auth: { studentId },
      showForumModal,
      upvoteForumQuestion,
      downvoteForumQuestion,
      upvoteForumAnswer,
      downvoteForumAnswer,
      acceptForumAnswer,
    } = this.props

    const { user: author = {}, comments = [], answers = [] } = questionData

    const { activeTab } = this.state

    const textSchoolColor = { color: schoolData.primary_color }
    const selectedTabStyle = {
      borderBottom: `3px solid ${schoolData.primary_color}`,
    }

    let routeList = {
      "/": "Home",
      "/forums": "Forums",
      [`/forums/topic/${questionData.id}`]: "Topic",
    }

    const isQuestionAnswered = true

    return (
      <PageContainer isPageLoading={isLoadingQuestionData}>
        <HeroHeader
          title="Topic"
          description="Browsing a specific topic."
          routeList={routeList}
          activeColor={schoolData.primary_color}
          activeItem="Topic"
        />
        <div className="topic-container">
          <TopicCard
            author={author.full_name || author.username}
            photo={author.photo}
            pubTimestamp={questionData.pub_date}
            editTimestamp={questionData.updated}
            isAuthor={author.id === parseInt(studentId)}
            isClosed={questionData.closed}
            views={questionData.view_count}
            reply={questionData.answer_count || answers.length}
            title={questionData.title}
            content={questionData.description}
            tags={questionData.tags}
            linkDisabled={true}
            buttonEnabled={true}
            upvotes={questionData.positive_votes}
            downvotes={questionData.negative_votes}
            onClickComment={() =>
              showForumModal({ type: FORUM_MODAL_TYPES.COMMENT })
            }
            onClickAnswer={() =>
              showForumModal({ type: FORUM_MODAL_TYPES.ANSWER })
            }
            onClickClose={() => this.handleCloseQuestion(questionData)}
            onClickEdit={() => this.handleEditQuestion()}
            onClickUpvote={() => upvoteForumQuestion({ id: questionData.id })}
            onClickDownvote={() =>
              downvoteForumQuestion({ id: questionData.id })
            }
            voteStatus={questionData?.vote}
            color={schoolData.primary_color}
          />
          <Tabs selectedTabClassName="select-tab" onSelect={this.onChangeTab}>
            <TabList className="topic-menu">
              <Tab
                className="neutral-tab"
                style={activeTab === 0 ? selectedTabStyle : {}}
              >
                <p>
                  <span style={textSchoolColor}>({answers.length})</span>{" "}
                  Answers
                </p>
              </Tab>
              <Tab
                className="neutral-tab"
                style={activeTab === 1 ? selectedTabStyle : {}}
              >
                <p>
                  <span style={textSchoolColor}>({comments.length})</span>{" "}
                  Comments
                </p>
              </Tab>
            </TabList>
            <TabPanel>
              {answers?.length ? (
                answers.map((answer) => {
                  const { user = {}, comments = [] } = answer
                  return (
                    <Reviews
                      type="answer"
                      key={answer.id}
                      id={answer.id}
                      review={answer.answer_text}
                      pubTimestamp={answer.pub_date}
                      editTimestamp={answer.updated}
                      commentor={user.full_name || user.username}
                      upvotes={answer.positive_votes}
                      downvotes={answer.negative_votes}
                      acceptedAnswer={answer.answer}
                      isAuthor={user.id === parseInt(studentId)}
                      onClickUpvote={() => upvoteForumAnswer(answer.id)}
                      onClickDownvote={() => downvoteForumAnswer(answer.id)}
                      onClickEdit={() => this.handleEditAnswer(answer)}
                      onClickAccept={() => acceptForumAnswer(answer.id)}
                      isQuestionAuthor={author.id === parseInt(studentId)}
                      isAnswered={answer.answer}
                      isQuestionAnswered={isQuestionAnswered}
                      showCommentForm={true}
                      comments={comments}
                      addCommentToAnswer={() =>
                        this.handleAddCommentToAnswer(answer)
                      }
                      color={schoolData.primary_color}
                      voteStatus={answer.vote}
                    />
                  )
                })
              ) : (
                <div className="has-text-centered">No answers found</div>
              )}
            </TabPanel>
            <TabPanel>
              {comments?.length ? (
                comments.map((comment) => {
                  const { user = {} } = comment
                  return (
                    <Reviews
                      type="comment"
                      key={comment.id}
                      id={comment.id}
                      review={comment.comment_text}
                      isAuthor={user.id === parseInt(studentId)}
                      pubTimestamp={comment.pub_date}
                      editTimestamp={comment.updated}
                      commentor={user.full_name || user.username}
                      onClickEdit={() => this.handleEditComment(comment)}
                      showCommentForm={false}
                    />
                  )
                })
              ) : (
                <div className="has-text-centered">No comments found</div>
              )}
            </TabPanel>
          </Tabs>
        </div>
      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.authReducer,
  user: state.userReducer,
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getQuestionById,
      submitForumQuestion,
      showForumModal,
      upvoteForumQuestion,
      downvoteForumQuestion,
      upvoteForumAnswer,
      downvoteForumAnswer,
      setForumAnswerData,
      setForumCommentData,
      acceptForumAnswer,
      showConfirmModal,
      closeConfirmModal,
      closeForumQuestion,
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(Topic)
